(function () {
  'use strict';

  var FORM_SELECTOR = '[data-search-suggest-form]';

  function hidePanel(panel) {
    panel.classList.remove('is-visible');
    panel.setAttribute('hidden', '');
  }

  function showPanel(panel) {
    panel.removeAttribute('hidden');
    panel.classList.add('is-visible');
  }

  function initSearchForm(form) {
    var input = form.querySelector('.js_iput_search, input[name="q"]');
    if (!input) return;

    var wrapper =
      input.closest('.t4s-search-form__input-wrapper') || input.parentElement;
    if (!wrapper) return;

    var panel = wrapper.querySelector('.t4s-search-suggest-panel');
    if (!panel) return;

    wrapper.classList.add('t4s-search-suggest-anchor');

    var hideTimer = null;
    var panelHovered = false;
    var wrapperHovered = false;

    function inputIsEmpty() {
      return !input.value.trim();
    }

    function tryShowPanel() {
      if (!inputIsEmpty()) {
        hidePanel(panel);
        return;
      }
      showPanel(panel);
    }

    function scheduleHide() {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        if (!panelHovered && !wrapperHovered && document.activeElement !== input) {
          hidePanel(panel);
        }
      }, 180);
    }

    input.addEventListener('focus', tryShowPanel);
    input.addEventListener('mouseenter', tryShowPanel);

    wrapper.addEventListener('mouseenter', function () {
      wrapperHovered = true;
      tryShowPanel();
    });

    wrapper.addEventListener('mouseleave', function () {
      wrapperHovered = false;
      scheduleHide();
    });

    input.addEventListener('blur', scheduleHide);

    input.addEventListener('input', function () {
      if (inputIsEmpty()) {
        tryShowPanel();
      } else {
        hidePanel(panel);
      }
    });

    panel.addEventListener('mouseenter', function () {
      panelHovered = true;
      clearTimeout(hideTimer);
    });

    panel.addEventListener('mouseleave', function () {
      panelHovered = false;
      scheduleHide();
    });
  }

  function boot() {
    document.querySelectorAll(FORM_SELECTOR).forEach(initSearchForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
